import React from 'react';

import DatagridRowPhaisinh from './DatagridRowPhaisinh';

function DatagridPhaisinh(props) {
  const { clickSymbol, resource, children, className } = props;

  const handleOpenModal = (sym) => {
    clickSymbol(sym);
  };

  return (
    <table className={className + ''}>
      <colgroup>
        <col width="5.5%"></col>
        {/** sym */}
        <col width="3.6%"></col>
        {/** tc */}
        <col width="3.6%"></col>
        {/** tran */}
        <col width="3.6%"></col>
        {/** san */}
        <col width="3.6%"></col>
        {/** gia 3 */}
        <col width="3.4%"></col>
        {/** kl 3 */}
        <col width="3.6%"></col>
        {/** giá 2 */}
        <col width="3.4%"></col>
        {/** kl 2 */}
        <col width="3.6%"></col>
        {/** gia 1 */}
        <col width="3.4%"></col>
        {/** kl 1 */}
        <col width="3.6%"></col>
        {/** gia khop */}
        <col width="4.4%"></col>
        {/** kl khop */}
        <col width="3.6%"></col>
        {/** +/- */}
        <col width="3.6%"></col>
        {/** # */}
        <col width="3.6%"></col>
        {/** gia 1 */}
        <col width="3.4%"></col>
        {/** kl 1 */}
        <col width="3.6%"></col>
        {/** gia 2 */}
        <col width="3.4%"></col>
        {/** kl 2 */}
        <col width="3.6%"></col>
        {/** gia 3 */}
        <col width="3.4%"></col>
        {/** kl 3 */}
        <col width="6.2%"></col>
        {/** tong kl */}
        <col width="3.8%"></col>
        {/** cao */}
        <col width="3.6%"></col>
        {/** thap */}
        <col width="3.6%"></col>
        {/** tb */}
        <col width="4.6%"></col>
        {/** nn mua */}
        <col width="4.6%"></col>
        {/** nn ban */}
      </colgroup>
      {children && (
        <thead className="bb-1-haft ">{children}</thead>
      )}
      <tbody>
        {resource &&
          !!resource.length &&
          resource.map((item, index) => (
            <DatagridRowPhaisinh
              record={item}
              key={`${item.sym}-${index}`}
              handleOpenModal={handleOpenModal}
            />
          ))}
      </tbody>
    </table>
  );
}

export default DatagridPhaisinh;
